var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/compose_form_button.tsx";
import classNames from 'classnames';
import React from 'react';
import { IconButton } from 'soapbox/components/ui';
const ComposeFormButton = ({
  icon,
  title,
  active,
  disabled,
  onClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classNames('text-gray-400 hover:text-gray-600', {
      'text-primary-600 hover:text-primary-500 dark:text-primary-400 dark:hover:text-primary-300': active
    }),
    src: icon,
    title: title,
    disabled: disabled,
    onClick: onClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }));
};
export default ComposeFormButton;